const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/modules/auth/views/login/index.vue'),
  },
];

export default routes;
